<template>
  <!-- Mission List Popup -->
  <div>
    <el-dialog
      title="Bình luận"
      :visible.sync="mainDialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <!-- <div class="das-form-container"> -->
      <div class="das-info-title">
        Thông tin đặt phòng {{ bookingInfo.booking_group_code }}
      </div>
      <hr />
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày đến</InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_in_date)
        }}</InfoListValue>

        <InfoListLabel>Đoàn</InfoListLabel>
        <InfoListValue>{{ bookingInfo.booking_group_name }}</InfoListValue>

        <InfoListLabel>Số điện thoại</InfoListLabel>
        <InfoListValue>{{ bookingInfo.phone_number }}</InfoListValue>

        <InfoListLabel>Ngày đi </InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_out_date)
        }}</InfoListValue>

        <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
        <InfoListValue>{{ bookingInfo.agent_name }}</InfoListValue>
      </InfoList>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="missionListGrid"
          :columns="cols"
          dom-layout="scroll"
          :auto-select-first-row="false"
          :rows="rows"
          class="agGrid"
          @selectionChanged="onSelectionChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="mainDialogVisible = false"
          >
            Đóng
          </button>
          <!-- Messages -->
          <div class="flex gap-10">
            <button
              :disabled="
                rowsSelected.length === 0 ||
                rowsSelected[0]?.status === 3 ||
                rowsSelected[0]?.status === 2
              "
              class="btn primary small"
              @click="openHandleRowDialog()"
            >
              Xử lý bình luận
            </button>
            <button
              :disabled="
                rowsSelected.length === 0 || rowsSelected[0]?.status === 3
              "
              class="btn primary small"
              @click="cancelHandleRow()"
            >
              Hủy bình luận
            </button>
            <button
              :disabled="
                rowsSelected.length === 0 ||
                rowsSelected[0]?.status === 3 ||
                rowsSelected[0]?.status === 1
              "
              class="btn primary small"
              @click="undoComment()"
            >
              Hoàn tác
            </button>
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="editComment()"
            >
              Chi tiết bình luận
            </button>
            <button class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div>
          <!-- <div class="flex gap-10">
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="onSendMessage()"
            >
              Gửi
            </button>
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="openCancelMessageDialog()"
            >
              Hủy
            </button>
            <button class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div> -->
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="isEdit ? 'Chi tiết bình luận' : 'Thêm bình luận'"
      :visible="addDialogVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="onDialogClose"
    >
      <validation-observer ref="createFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:50" name="Người gửi">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Người gửi</span>
                    </div>

                    <input
                      v-model="submitForm.sender"
                      :disabled="rowsSelected[0]?.status !== 1 && isEdit"
                      type="text"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:200" name="Nội dung">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Nội dung</span>
                    </div>
                    <textarea
                      v-model="submitForm.content"
                      :disabled="rowsSelected[0]?.status !== 1 && isEdit"
                      :rows="3"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addDialogVisible = false"
          >
            Đóng
          </button>
          <button
            v-if="isEdit"
            :disabled="rowsSelected[0]?.status !== 1"
            class="btn primary small"
            @click="onUpdate()"
          >
            Cập nhật
          </button>
          <button v-else class="btn primary small" @click="onSubmitNew()">
            Tạo mới
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Xử lý"
      :visible="addHandleDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <validation-observer ref="processFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:200" name="Ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Ghi chú</span>
                    </div>
                    <textarea v-model="addProcessForm.note" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addHandleDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="submitHandleForm()">
            Thêm
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addForm,
  handleRow,
  getComments,
  handleCancelRow,
  undoCommentApi,
  onUpdateApi
} from '@/api/cashier_service/postTransaction'
export default {
  data() {
    return {
      isEdit: false,
      mainDialogVisible: false,
      addDialogVisible: false,
      rowsSelected: [],
      submitForm: {
        id: null,
        sender: null,
        phone_num: null,
        purpose: null,
        content: null,
        sub_booking_group_id: null
      },
      cols: [
        {
          headerName: 'Người gửi',
          field: 'sender',
          tooltipField: 'sender',
          width: 120
        },
        {
          headerName: 'Người tạo',
          field: 'sender',
          tooltipField: 'sender',
          width: 120
        },
        {
          headerName: 'Thời gian tạo',
          field: 'create_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.create_date) || null
          },
          width: 120
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          valueGetter: param => {
            let output = ''
            switch (param?.data?.status) {
              case 1:
                output = 'Chưa xử lý'
                break
              case 2:
                output = 'Đã xử lý'
                break
              case 3:
                output = 'Đã hủy'
                break
              default:
                break
            }
            return output
          },
          width: 120
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          tooltipField: 'content',
          minWidth: 200
        },
        {
          headerName: 'Người hủy, xử lý',
          field: 'handle_or_cancel_user_name',
          tooltipField: 'handle_or_cancel_user_name'
        },
        {
          headerName: 'Thời gian hủy, xử lý',
          field: 'handle_or_cancel_date',
          valueGetter: param => {
            if (param?.data?.handle_or_cancel_date) {
              return this.$moment(param?.data?.handle_or_cancel_date).format(
                'DD/MM/YYYY HH:mm'
              )
            } else {
              return null
            }
          },
          width: 160
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',
          minWidth: 200
        }
      ],
      rows: [],
      // ***************************************
      addHandleDialog: false,
      addProcessForm: {
        note: null
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    }
  },
  watch: {
    addHandleDialog() {
      this.addHandleDialog ? null : this.$nullValueInObj(this.addProcessForm)
    }
  },
  methods: {
    onDialogClose() {
      this.isEdit = false
      this.$nullValueInObj(this.submitForm)
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
    },
    async onUpdate() {
      if (
        (await this.$vxForm.isValid(this.$refs.createFormValidator)) === false
      ) {
        return
      }
      await onUpdateApi(this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editComment() {
      this.isEdit = true
      Object.assign(this.submitForm, this.rowsSelected[0])
      this.addDialogVisible = true
    },
    async undoComment() {
      const id = this.rowsSelected[0]?.id
      await undoCommentApi(id)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onSubmitNew() {
      if (
        (await this.$vxForm.isValid(this.$refs.createFormValidator)) === false
      ) {
        return
      }
      const url = '/cashier-service/v1/room-comment'
      await addForm(url, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      const data = await getComments({
        sub_booking_group_id: this.bookingInfo.id
      })
      this.rows = data.data || []
      this.rowsSelected = []
    },
    async getInitData() {
      await this.attachData()
      this.mainDialogVisible = true
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
    },
    openAddDialog() {
      this.addDialogVisible = true
    },
    onSelectionChange(rows) {
      this.rowsSelected = rows
    },
    // *********************************
    openHandleRowDialog() {
      this.addHandleDialog = true
    },
    async cancelHandleRow() {
      const id = this.rowsSelected[0].id
      await handleCancelRow(`/cashier-service/v1/room-comment/${id}/cancel`)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async submitHandleForm() {
      if (
        (await this.$vxForm.isValid(this.$refs.processFormValidator)) === false
      ) {
        return
      }
      const id = this.rowsSelected[0].id
      const url = `/cashier-service/v1/room-comment/${id}/handle`
      await handleRow(url, this.addProcessForm)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
